import slLogo from "./images/sl.png";
import About from "./pages/about/About";
import Bank from "./pages/bank/Bank";
import Calendar from "./pages/calendar/Calendar";
import Feedback from "./pages/feedback/Feedback";
import Kyc from "./pages/Kyc/Kyc";
import Liverate from "./pages/liverate/Liverate";
import Update from "./pages/updates/Update";

export const DMNNMSTTG = {
    DMNNM: 'b1.starlinedashboard',
    DMN: 'in',
    ENDPNT: '/api/bullion',
    SKTPRT: '10001',
};

export const apiUrl = `https://${DMNNMSTTG.DMNNM}.${DMNNMSTTG.DMN}${DMNNMSTTG.ENDPNT}`;
export const adminsocketurl = `https://${DMNNMSTTG.DMNNM}.${DMNNMSTTG.DMN}:${DMNNMSTTG.SKTPRT}`;
export const prjName = "titli";
export const footerData = {
    copyright: "©2026 TITLI JEWELLERS",
    companyName: "Starline Solutions Pvt Ltd.",
    logo: slLogo,
    companyLink: "http://www.starlinetechno.net/",
};
export const androidUrl = "https://play.google.com/store/apps/details?id=com.titlijwellers";
export const iosUrl = "";


export const hasOtr = false;
export const hasViewBtn = true;
export const pushMenu = false;
export const menuTitleArr = [
    {
        id: "1",
        path: "about_us",
        name: "About Us",
        display: true,
        element: <About />,
        icon: "bi-people"



    },
    {
        id: "2",
        path: "",
        name: "Liverate",
        display: true,
        element: <Liverate />,
        icon: "bi-graph-up-arrow"

    },
    {
        id: "3",
        path: "coin",
        name: "Coins",
        display: false,
        element: ""
    },
    {
        id: "4",
        path: "kyc",
        name: "Kyc",
        display: true,
        element: <Kyc />,
        icon: "bi-person-check"


    },
    {
        id: "5",
        path: "update",
        name: "Updates",
        display: true,
        element: <Update />,
        icon: "bi-bell"
    },
    {
        id: "6",
        path: "bankDetail",
        name: "Bank Details",
        display: true,
        element: <Bank />,
        icon: "bi-bank"

    },
    {
        id: "7",
        path: "calculator",
        name: "Calculator",
        display: false,
        element: "",
        icon: "bi-people"
    },
    {
        id: "8",
        path: "calendar",
        name: "Economic Calendar",
        display: false,
        element: <Calendar />,
    },
    {
        id: "9",
        path: "contact-details",
        name: "Contact Details",
        display: true,
        element: <Feedback />,
        icon: "bi-telephone"

    }
];